module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-4-dc4a11ed177453268ac3c52ff3d88035.webp";